import React, { useEffect, useState } from 'react';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
  CircularProgress,
  Button,
} from '@mui/material';
import axios from 'axios';
import SuperAdminLayout from '../../../layouts/SuperAdminLayout';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import api from '../../../utils/api';

const SalesReport = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const fetchSales = async () => {
      try {
        const res = await api.get(`/api/reports/sales-report/${user.id}`);
        setData(res.data);
      } catch (err) {
        console.error('Error fetching sales report:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSales();
  }, [user.id]);

  const downloadExcel = () => {
    const rows = data.map((challan) => {
      const items = challan.items ?? [];

      const productNames = items.map((item) => item.product).join(', ');
      const quantities = items
        .map((item) => (item.quantity ?? 0).toFixed(2))
        .join(', ');
      const rates = items
        .map((item) => (item.price ?? 0).toFixed(2))
        .join(', ');
      const totals = items
        .map((item) => ((item.quantity ?? 0) * (item.price ?? 0)).toFixed(2))
        .join(', ');

      return {
        'Challan No': challan.challanNumber,
        Customer: challan.customer,
        Date: challan.date.slice(0, 10),
        Products: productNames,
        Quantity: quantities,
        Rate: rates,
        Total: totals,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sales Report');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'sales-report.xlsx');
  };

  return (
    <SuperAdminLayout>
      <Typography variant="h6" sx={{ mt: 2 }}>
        Sales Report
      </Typography>

      <Button
        variant="contained"
        color="success"
        sx={{ mb: 2 }}
        onClick={() => downloadExcel()}
      >
        Download Excel
      </Button>
      {loading ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Challan #</TableCell>
                <TableCell>Party Name</TableCell>
                <TableCell>Products</TableCell>
                <TableCell>Quantities</TableCell>
                <TableCell>Rates</TableCell>
                <TableCell>Totals</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell>{row.challanNumber}</TableCell>
                  <TableCell>{row.partyName}</TableCell>
                  <TableCell>
                    {row.products.map((p, i) => (
                      <div key={i}>{p.name}</div>
                    ))}
                  </TableCell>
                  <TableCell>
                    {row.products.map((p, i) => (
                      <div key={i}>{p.quantity}</div>
                    ))}
                  </TableCell>
                  <TableCell>
                    {row.products.map((p, i) => (
                      <div key={i}>₹{p.rate}</div>
                    ))}
                  </TableCell>
                  <TableCell>
                    {row.products.map((p, i) => (
                      <div key={i}>₹{p.total}</div>
                    ))}
                  </TableCell>
                  <TableCell>{row.date}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </SuperAdminLayout>
  );
};

export default SalesReport;
